import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const samosetConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Samoset Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Samoset, FL. Sam\'s Tree Service handles hazardous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_samoset',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Samoset',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Samoset Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the homes and businesses of 
     <strong>Samoset</strong> with expert, no nonsense tree care. Sitting at the crossroads 
     of Bradenton and Sarasota, this community experiences the full force of Florida's 
     storm season and the tree damage that comes with it. Overgrown canopies, split 
     limbs, and trees pushed off balance by wind and saturated soil are all jobs we handle 
     with professionalism and care.`,

    `We specialize in <strong>hazardous tree removal and precision trimming</strong> 
     addressing large limbs overhanging driveways and rooftops, trees with root or trunk 
     damage from flooding, storm compromised palms, and dense growth that needs targeted 
     reduction to keep your property safe. We work efficiently and clean up completely 
     when we're done.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>Samoset</strong> and across the <strong>Bradenton Sarasota</strong> 
     metro area giving your property the professional attention it deserves through 
     every season.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Samoset, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Samoset = () => <LocationPage config={samosetConfig} />;
export default Services_Samoset;
